
  import {Component, Vue} from "vue-property-decorator";
  import breadcrumb from "@/components/common/breadcrumb.vue";
  import upload from "@/components/upload/src/index.vue";
  import {getAuditInfo, noAuditCountGroupByCountry, saveAuditInfo, showCountGroupByCountry} from '@/services/api';
  import validator from "@/services/validator";

  @Component({
    components: {
      'zf-breadcrumb': breadcrumb,
      'zf-upload': upload
    },
  })
  export default class ItemModify extends Vue{
    //面包屑导航
    public navList: {name: String, to?: String}[] = [
      {name: '审核列表', to: '/audit'},
      {name: '审核修改'}
    ];
    // 地区
    public country!: string;
    public countryList: string[] = ['HK', 'JP', 'MY', 'SG', 'TH', 'TW', 'PH'];
    // 语言
    public language!: string;
    public languageList: string[] = ['zh', 'en', 'th', 'jp', 'tl'];
    // 今日分地区已/未上传审核通过的数量
    public todayAuditList: {country: string, passed: number, count: number}[] = [];
    public todayNoAuditList: {country: string, count: number}[] = [];
    //显示的表单信息
    private auditType = '';
    public itemForm: {
      auditType: string,
      audit: {
        id: number,
        itemId: number,
        status: string,
        reason: string,
        auditCreater: string,
        strategyKey: string,
        strategy: string
      },
      brandInfo: {
        image: string
        location: {
          top: number,
          left: number,
          width: number,
          height: number
        }
        name: string
        probability: number
        type: number
      },
      display: {
        covers: string[],
        details: string[],
        itemId: number,
        itemTitle: string,   //item标题
        itemPrice: number,   //item价格
        goodList: [
          {
            goodId: number,
            goodTitle: string,  //套餐名称
            goodPrice: number    //套餐价格
          }
        ]
      },
      item: {
        adId: number,
        body: string,
        country: string,
        images: string[],
        itemId: number,
        copiedItemId: number,
        language: string,
        linkUrl: string,
        tempLinkUrl: string,
        title: string,
        video: string,
        videoPreview: string,
        status: string,
        reason: string
      }
    } | null = null;

    // 上传图片地址
    public uploadUrl = (process.env.VUE_APP_BASE_API.length == 0 ? (location.origin + "/") : process.env.VUE_APP_BASE_API) + 'api/audit_interface/uploadImages';
    // 轮播图回显列表
    public coverShowList: {url: string, name: string}[] = [];
    // 轮播图上传列表
    public coverList: {url: string, name: string}[] = [];
    // 详情图回显列表
    public detailShowList: {url: string, name: string}[] = [];
    // 详情图上传列表
    public detailList: {url: string, name: string}[] = [];
    // 大图展示控制
    public dialogVisible = false;
    // 大图展示路径
    public dialogImageUrl = '';
    // 预加载视频
    preloadVideo = "";
    // 商标图片
    brandImgWidth = 500;
    brandInfo!: {
      top: number,
      left: number,
      width: number,
      height: number
    } | null;

    public auditTypeOptions: {key: string, value: string}[] = [];

    created(): void {
      this.auditType = this.$route.params.auditType || '';
      if (this.auditType === 'gray') {
        this.auditTypeOptions = [{key: '10', value: '灰名单通过'}, {key: '2', value: '产品违规'}, {key: '5', value: '视频违规'}, {key: '6', value: '规格或套餐错误'}, {key: '4', value: '规格带价格或图片'}];
        this.navList = [
          {name: '灰名单审核', to: '/audit/gray'},
          {name: '审核修改'}
        ];
      } else {
        this.auditTypeOptions = [{key: '1', value: '审核通过'}, {key: '2', value: '产品违规'}, {key: '5', value: '视频违规'}, {key: '6', value: '规格或套餐错误'}, {key: '4', value: '规格带价格或图片'}];
      }


      this.showCountGroupByCountry();
      this.country = window.localStorage.auditCountry || 'TW';
      this.language = window.localStorage.auditLanguage || 'zh';
    }

    setStorage(key: string, value: string): void{
      window.localStorage.setItem(key, value);
      this.$forceUpdate();
    }

    /**
     * 今日已审核item数量
     */
    showCountGroupByCountry(): void {
      showCountGroupByCountry(this.auditType)
        .then(res => {
          if (res.data && res.data.result) {
            this.todayAuditList = res.data.result;
          }
        })
      noAuditCountGroupByCountry(this.auditType)
        .then(res => {
        if (res.data && res.data.result) {
          this.todayNoAuditList = res.data.result;
        }
      })
    }

    /**
     * 获取item信息
     */
    async getAuditInfo(): Promise<void> {
      await getAuditInfo(this.country, this.language, this.auditType, true).then(res => {
        if (this.$refs.audit) {
          const audit: any = this.$refs.audit;
          audit.scrollTop = 0;
        }
        this.itemForm = null;
        if (!res.data || !res.data.result || res.data.result.length == 0) {
          return;
        }
        if ( res.data.result.length == 0) {
          this.$message.error('没有需要审核的产品');
          return;
        }
        this.itemForm = res.data.result[0];
        if (!this.itemForm) {
          return;
        }
        this.itemForm.audit.status = '';
        this.coverList = this.itemForm.display.covers.map((url: string) => ({
          name: '',
          url
        }))
        this.coverShowList = [...this.coverList]
        this.detailList = this.itemForm.display.details.map((url: string) => ({
          name: '',
          url
        }))
        this.detailShowList = [...this.detailList]
        this.brandInfo = null;
        if (this.itemForm.brandInfo) {
          this.getImgRawSize(this.itemForm.brandInfo.image).then((res: {width: number, height: number}) => {
            const rate = this.brandImgWidth / res.width;
            this.brandInfo = {
              left: (this.itemForm?.brandInfo.location.left || 0) * rate,
              top: (this.itemForm?.brandInfo.location.top || 0) * rate,
              height: (this.itemForm?.brandInfo.location.height || 0) * rate,
              width: (this.itemForm?.brandInfo.location.width || 0) * rate
            }
          })
        }

        this.$forceUpdate();

        if(res.data.result[1]) {
          const next = res.data.result[1];
          const preImgList = [
            ...next.display.covers || [],
            ...next.display.details || [],
            ...next.item.images||[],
            next.item.videoPreview || ''
          ]
          setTimeout(() => {
            for (const url of preImgList) {
              // 图片预加载
              this.preLoadImg(url);
            }
            // 视频预加载
            this.preloadVideo = next.item.video;
          }, 1000)
        }
      });
    }

    getImgRawSize2(brandImg: any) {
      let i = 0;
      const timer = setInterval(() => {
        i ++;
        if (i >= 1200) {
          clearInterval(timer)
        }


      }, 500)
    }

    getImgRawSize(img: any): Promise<{width: number, height: number}> {
      return Promise.resolve(new Promise(function(reslove, reject){
        if (img instanceof HTMLImageElement) {
          if (img.naturalWidth) {
            return reslove({width: img.naturalWidth, height: img.naturalHeight});
          }
          img = img.src;
        } else if (typeof img === 'string') {
          let _image = new Image();
          _image.src = img;
          _image.onload = () => reslove({
            width: _image.naturalWidth || _image.width,
            height: _image.naturalHeight || _image.height
          })
          _image.onerror = () => reject({
            width: 0,
            height: 0
          })
        }
      }))
    }

    preLoadImg(url: string) {
      const img = new Image();
      img.src = url;
    }

    /**
     * 保存表单
     */
    onSubmit(): void {
      if (this.checkForm()){
        this.saveAuditInfo();
      }
    }

    /**
     * 更新item和套餐信息
     */
    saveAuditInfo(): void {
      if (!this.itemForm) {
        return;
      }
      this.itemForm.display.covers = this.coverList.map(item => item.url)
      this.itemForm.display.details = this.detailList.map(item => item.url)
      this.itemForm.auditType = this.auditType;
      saveAuditInfo(this.itemForm).then(async res =>{
        if (res.data && res.data.status==='OK'){
          this.$message({
            showClose: true,
            message: '修改成功！',
            type: 'success'
          });
          await this.getAuditInfo();
          this.showCountGroupByCountry();
        } else {
          this.$message({
            showClose: true,
            message: '修改失败，请检查网络后重试！',
            type: 'warning'
          });
        }
      });
    };

    /**
     * 校验表单内容是否通过
     */
    checkForm(): boolean {
      if (!this.itemForm) {
        return false;
      }
      if (!this.testRequired(validator({required:true, requiredMsg: '产品标题不能为空'}, this.itemForm.display.itemTitle), 'itemTitle')){
        return false;
      }
      if (!this.testRequired(validator({required:true, requiredMsg: '产品价格不能为空', type: 'price'}, this.itemForm.display.itemPrice), 'itemPrice')){
        return false;
      }
      for (const x in this.itemForm.display.goodList) {
        if (!this.testRequired(validator({required:true, requiredMsg: '套餐名称不能为空'}, this.itemForm.display.goodList[x].goodTitle), 'goodTitle' + x)){
          return false;
        }
        if (!this.testRequired(validator({required:true, requiredMsg: '套餐价格不能为空', type: 'price'}, this.itemForm.display.goodList[x].goodPrice), 'goodPrice' + x)){
          return false;
        }
      }
      if (!this.testRequired(validator({required:true, requiredMsg: '请选择审核状态'}, this.itemForm.audit.status), 'status')){
        return false;
      }
      if (this.itemForm.audit.status !== '1' && this.itemForm.audit.status !== '10' && !this.testRequired(validator({required:true, requiredMsg: '请选择不通过原因'}, this.itemForm.audit.reason), 'reason')) {
        return false;
      }
      return true;
    }

    /**
     * 表单验证提示
     * @param msg 错误信息
     * @return boolean 检测通过，没有错误信息为true
     */
    testRequired(msg: string | undefined, ref: string): boolean {
      if (msg) {
        this.$message.error(msg);
        if (ref) {
          const ele: any = this.$refs[ref];
          if (ele instanceof Array) {
            ele[0].focus()
          } else {
            ele.focus();
          }
        }
        return false;
      } else {
        return true;
      }
    }

    /**
     * 图片删除前确认钩子函数
     */
    beforeRemove() {
      return this.$confirm(`确定移除该图片吗？`);
    }

    /**
     * 轮播图删除钩子函数
     */
    handleRemove(file: {name: string, url: string}, list: any) {
      this.coverList = [...list];
      this.coverShowList = [...list];
    }

    /**
     * 轮播图上传成功钩子函数
     */
    handleSuccess(res: any,file: any,fileList: any) {
      if (res && res['result'][0]) {
        file.url = res['result'][0]
        // 图片根据上传顺序重新排序
        let front;
        for (let [index, item] of fileList.entries()) {
          if(item.status !== 'success' && !front) {
            front = index;
          }
          if (item.uid === file.uid && front) {
            fileList.splice(front,1,...fileList.splice(index, 1 , fileList[front]))
            break;
          }
          this.coverShowList = fileList;
        }
        this.coverList.push(file)
      }
    }

    /**
     * 详情图删除钩子函数
     */
    handleRemove1(file: {name: string, url: string}, list: any) {
      this.detailList = [...list];
      this.detailShowList = [...list];
    }

    /**
     * 详情图上传成功钩子函数
     */
    handleSuccess1(res: any,file: any,fileList: any) {
      if (res && res['result'][0]) {
        file.url = res['result'][0]
        // 图片根据上传顺序重新排序
        let front;
        for (let [index, item] of fileList.entries()) {
          if(item.status !== 'success' && !front) {
            front = index;
          }
          if (item.uid === file.uid && front) {
            fileList.splice(front,1,...fileList.splice(index, 1 , fileList[front]))
            break;
          }
          this.detailShowList = fileList;
        }
        this.detailList.push(file)
      }
    }

    /**
     * 图片上传失败钩子函数
     */
    handleError(e: any): void {
      this.$message.warning('图片上传失败！');
      if(e.status === 401) {
        // 如果返回401 即没有权限，跳到登录页重新登录
        this.$alert('登录失效，请重新登录')
        this.$router.replace({
          path: '/login',
          query: {redirect: this.$router.currentRoute.fullPath}
        })
      }
    }

    /**
     * 图片展示
     */
    handlePictureCardPreview(file: {name: string, url: string}) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true;
    }
  }
